import styled from "styled-components";
import Slider from "react-slick";

const Wrap = styled.div`
  margin: 0 auto;
  padding: 100px 0;
  max-width: 1200px;

  .slick-dots {
    bottom: -80px;

    ul {
      li {
      }

      li > button {
        display: initial;
      }

      li > button::before {
        content: "";
        width: 6px;
        height: 6px;
        transition: all 0.25s ease;
        border-radius: 50%;
        margin-left: 11px;
        background-color: transparent;
        box-shadow: inset 0 0 0 5px #000;
      }

      li.slick-active > button::before {
        transform: scale(2);
        box-shadow: inset 0 0 0 1px #000;
        background-color: transparent;
      }
    }
  }

  @media (max-width: 1000px) {
    padding: 0 20px;

    .slick-dots {
      bottom: initial;
    }
  }
`;
const SlickWrap = styled.div`
  cursor: grab;
`;
const SlickContent = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 1000px) {
    flex-direction: column;
  }
`;
const IframeWrap = styled.div`
  padding-top: 30%;
  position: relative;
  width: 50%;

  & > iframe {
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    margin: 0;
    top: 0;
    left: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border: none;
    border-radius: 10px;
  }

  @media (max-width: 1000px) {
    padding-top: 56.25%;
    width: 100%;
  }
`;
const DescWrap = styled.div`
  padding: 0 0 50px 50px;
  width: 50%;

  @media (max-width: 1000px) {
    padding: 30px 0;
    width: 100%;
  }
`;
const DescSubTitle = styled.p`
  margin-bottom: 7px;
  line-height: 32px;
  font-family: Hind;
  font-size: 1.75rem;
  font-weight: 400;
  color: #444;
  letter-spacing: 0;
  -webkit-font-smoothing: antialiased;
`;
const DescTitle = styled(DescSubTitle)`
  line-height: 50px;
  font-size: 44px;
  font-weight: 700;
`;
const Desc = styled(DescSubTitle)`
  line-height: 24px;
  font-size: 16px;
  color: #676767;
`;

export type TYoutubeItem = {
  src: string;
  title: string;
  descSubTitle: string;
  descTitle: string;
  desc: string;
};

export type TProps = {
  youtubeItems: TYoutubeItem[];
};

export default function YoutubeSlick(props: TProps) {
  if (props.youtubeItems.length < 2) {
    return (
      <Wrap>
        {props.youtubeItems.map((v) => (
          <SlickWrap key={v.src}>
            <SlickContent>
              <IframeWrap>
                <iframe loading="lazy" title={v.title} src={v.src} />
              </IframeWrap>
              <DescWrap>
                <DescSubTitle>{v.descSubTitle}</DescSubTitle>
                <DescTitle>{v.descTitle}</DescTitle>
                <Desc>{v.desc}</Desc>
              </DescWrap>
            </SlickContent>
          </SlickWrap>
        ))}
      </Wrap>
    );
  }

  return (
    <Wrap>
      <Slider
        {...{
          dots: true,
          autoplay: false,
          arrows: false,
          appendDots: (dots) => (
            <div>
              <ul>{dots}</ul>
            </div>
          ),
        }}
      >
        {props.youtubeItems.map((v) => (
          <SlickWrap key={v.src}>
            <SlickContent>
              <IframeWrap>
                <iframe loading="lazy" title={v.title} src={v.src} />
              </IframeWrap>
              <DescWrap>
                <DescSubTitle>{v.descSubTitle}</DescSubTitle>
                <DescTitle>{v.descTitle}</DescTitle>
                <Desc>{v.desc}</Desc>
              </DescWrap>
            </SlickContent>
          </SlickWrap>
        ))}
      </Slider>
    </Wrap>
  );
}
